export default __webpack_public_path__ + "static/media/bg-feedback-2.88e0ab12.png";